"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[386],{

/***/ 40386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);
/* harmony import */ var _components_global_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80772);
/* harmony import */ var _components_global_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96332);
/* harmony import */ var _components_global_Toast__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81530);
/* harmony import */ var _DynamicComponent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79426);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var ModalWrapper = function(_param) {
    var _blok = _param.blok, ModalContent = _blok.ModalContent, ModalButtonLabel = _blok.ModalButtonLabel, modalSize = _blok.modalSize, Button = _blok.Button, template = _blok.template, rest = _objectWithoutProperties(_param.blok, [
        "ModalContent",
        "ModalButtonLabel",
        "modalSize",
        "Button",
        "template"
    ]);
    var customButton = Button && Button[0] || {};
    var position = customButton.position, variant = customButton.variant, size = customButton.size, label = customButton.label;
    var maxWidth = {
        s: "566px",
        m: "702px",
        l: "984px" // 1000 - padding
    };
    var paddings = {
        s: "var(--spacing-base)",
        m: "var(--spacing-xl)",
        l: "var(--spacing-xl)"
    };
    // temp workaround to preview and test expired session modal
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showExpiredToast = ref[0], setShowExpiredToast = ref[1];
    if (template === "expired-session") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                callBack: function() {
                    setShowExpiredToast(true);
                },
                variant: "primary",
                size: "l",
                align: "center",
                type: "button",
                children: ModalButtonLabel
            }),
            showExpiredToast && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_Toast__WEBPACK_IMPORTED_MODULE_4__/* .ExpiredToast */ .vu, {
                successToastAction: function() {
                    setShowExpiredToast(false);
                }
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, _objectSpread({
        buttonPosition: position,
        buttonVariant: variant,
        ModalButtonLabel: label || ModalButtonLabel,
        modalPadding: template ? "0" : paddings[modalSize],
        maxWidth: maxWidth[modalSize],
        buttonSize: size,
        template: template
    }, rest, {
        children: ModalContent.map(function(blok) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DynamicComponent__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                blok: blok
            }, blok._uid);
        })
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (ModalWrapper);


/***/ })

}]);